// export * from "./base.dto";
// export * from "./gradepoint.dto";
// export * from "./cgpa.dto";
// export * from "./religion.dto";
// export * from "./maritalstatus.dto";
// export * from "./bloodgroup.dto";
// export * from "./catalogue.dto";
// export * from "./action.dto";
// export * from "./allergy.dto";
// export * from "./application.dto";
// export * from "./assignmentstatus.dto";
// export * from "./assignmenttype.dto";
// export * from "./attendance.dto";
// export * from "./bookingtype.dto";
// export * from "./booking.dto";
// export * from "./catalogue.dto";
// export * from "./category.dto";
// export * from "./certificate.dto";
// export * from "./certificatetType.dto";
// export * from "./childschool.dto";
// export * from "./classmapping.dto";
// export * from "./classofdegree.dto";
// export * from "./complainttype.dto";
// export * from "./course-allocation.dto";
// export * from "./course.dto";
// export * from "./coursemapping.dto";
// export * from "./courseoption.dto";
// export * from "./courseregistration.dto";
// export * from "./customerfollowup.dto";
// export * from "./department.dto";
// export * from "./duration.dto";
// export * from "./dutyroster.dto";
// export * from "./exeat.dto";
// export * from "./faculty.dto";
// export * from "./feesaccounthead.dto";
// export * from "./feesbreakdown.dto";
// export * from "./grade.dto";
// export * from "./general.dto";
// export * from "./genotype.dto";
// export * from "./grade-level.dto";
// export * from "./grade-type.dto";
// export * from "./item.dto";
// export * from "./itemType.dto";
// export * from "./jamb.dto";
// export * from "./jambsubject.dto";
// export * from "./laboratory.dto";
// export * from "./level.dto";
// export * from "./meal.dto";
// export * from "./mealType.dto";
// export * from "./medicals.dto";
// export * from "./notification-portal.dto";
// export * from "./onlinelectures.dto";
// export * from "./parent.dto";
// export * from "./parentcomplaint.dto";
// export * from "./parent-complaint-image.dto";
// export * from "./payment.dto";
// export * from "./paymentmode.dto";
// export * from "./paymentstatus.dto";
// export * from "./paymenttype.dto";
// export * from "./pickupmanagement.dto";
// export * from "./prescription.dto";
// export * from "./programmetype.dto";
// export * from "./question.dto";
// export * from "./rentals.dto";
// export * from "./rentalsItem.dto";
// export * from "./result.dto";
// export * from "./schedule.dto";
// export * from "./schoolsubject.dto";
// export * from "./semester.dto";
// export * from "./session.dto";
// export { ShelveDto } from "./shelve.dto";
// export * from "./sitting.dto";
// export * from "./snapshot.dto";
// export * from "./staff.dto";
// export * from "./staffcategory.dto";
// export * from "./staffposition.dto";
// export * from "./step.dto";
// export * from "./student-account-history.dto";
// export * from "./student-project.dto";
// export * from "./student.dto";
// export * from "./studentaccount.dto";
// export * from "./studentmigration.dto";
// export * from "./studentSubject.dto";
// export * from "./subject.dto";
// export * from "./subjecttype.dto";
// export * from "./subscription.dto";
// export * from "./support.dto";
// export * from "./supportchart.dto";
// export * from "./supportimages.dto";
// export * from "./term.dto";
// export * from "./timetable.dto";
// export * from "./vitalsign.dto";
// export * from "./watchlist.dto";
// export * from "./yearofadmission.dto";
// export * from "./entrymode.dto";
// export * from "./gender.dto";
// export * from "./graduationstatus.dto";
// export * from "./occupation.dto";
// export * from "./projecttitle.dto";
// export * from "./relationship.dto";
// export * from "./hostel.dto";
// export * from "./room.dto";
// export * from "./staff.dto";
// export * from "./hostelregistration.dto";
// export * from "./maphostelwarden.dto";
// export * from "./coursematrix.dto";
// export * from "./maximumcreditload.dto";
// export * from "./user.dto";
// export * from "./valor.bookings.dto";
// export * from "./valor.services.dto";
// export * from "./valorproperty.dto";
// export * from "./valor-room.dto";
// export * from "./propertyasset.dto";
// export * from "./valor.menu.dto";
// export * from "./valor.visiting.dto";
// export * from "./valor.search.dto";
// export * from "./valorservicetype.dto";
// export * from "./valor.picture.dto";
export * from './classification.dto';
export * from './scholarship-type.dto';
export * from './scholarship-award-duration.dto';
export * from './scholarship-category.dto';
export * from './scholarship-management.dto';
export * from './scholarship-payment.dto';
export * from './scholarship-session.dto';
export * from './community.dto';
export * from './epim-base.dto';

export * from './areaofinterest.dto';
export * from './club.dto';
export * from './contacttype.dto';
export * from './sector.dto';
export * from './league.dto';
export * from './property.dto';
export * from './organization.dto';
export * from './socialmediatype.dto';
export * from './language.dto';
export * from './stakeholdergroup.dto';
export * from './stakeholdersubgroup.dto';
export * from './stakeholderreference.dto';
export * from './politicalparty.dto';
export * from './stakeholder.dto';
export * from './title.dto';
export * from "./state.dto";
 export * from "./lga.dto";
// export * from './epims-country.dto';
// export * from './epims-state.dto';
// export * from './epims-lga.dto';
export * from './epims-gender.dto';
export * from './courseofstudy.dto';
export * from './epimsbank.dto';
export * from './engagement.dto';
export * from './lineofbusiness.dto';
export * from './engagementtype.dto';
export * from './engagementcategory.dto';
export * from './engagementdriver.dto';
export * from './company.dto';
export * from './document.dto';
export * from './documenttype.dto';
export * from './documentsecurity.dto';
export * from './documentphysicallocation.dto';
export * from './incident.dto';

export * from './epimsbank-detail.dto';

export * from './project-category.dto';
export * from './project-type.dto';
export * from './cluster.dto';
export * from './cluster-community.dto';
export * from './oil-block.dto';
export * from './oil-field.dto';
export * from './document-category.dto';
export * from './document-sub-category.dto';
export * from './gmou.dto';
export * from './project.dto';
export * from './progress-history-report.dto';
export * from './progress-meeting-report.dto';
export * from './project-report-master.dto';
export * from './project-activity.dto';
export * from './project-cluster.dto';
export * from './project-payment.dto';
export * from './project-stakeholder.dto';
export * from './project-document.dto';

export * from './correspondence-community.dto';
export * from './correspondence-action-party.dto';
export * from './correspondence-asset.dto';
export * from './correspondence-company.dto';
export * from './correspondence-function.dto';
export * from './correspondence-register.dto';
export * from './correspondence-request-cat.dto';
export * from './correspondence-request-type.dto';
export * from './correspondence-team.dto';
export * from './correspondence-tracker-history.dto';
export * from './correspondence-issue-category.dto';
export * from './correspondence-action-viewer.dto';
export * from './correspondence-action-response.dto';
export * from './correspondence-single-action.dto';

export * from './land-title.dto';
export * from './land-parcel.dto';
export * from './land-title-register.dto';
export * from './lessor-area-marker.dto';
export * from './lessor-rep.dto';
export * from './lessors.dto';
export * from './lessor-info.dto';
export * from './individual-acreage.dto';
export * from './address-book.dto';
export * from './storage-location.dto';
export * from './asset-location.dto';
export * from './land-title-name.dto';
export * from './land-title-audit-tray.dto';


export * from './obligation-asset.dto';
export * from './obligation-beneficiary.dto';
export * from './obligation-facility.dto';
export * from './obligation-land-lords-paid.dto';
export * from './obligation-payment-history.dto';
export * from './obligation-payment-master.dto';
export * from './obligation-payment-summary.dto';
export * from './obligation-payment-track.dto';
export * from './obligation-payment.dto';
export * from './obligation-registered-facility.dto';
export * from './facility-register-host.dto';
export * from './facility-registration.dto';
export * from './tenement-payment-master.dto';
export * from './ground-rent-rate.dto';
export * from './ground-rent-payment-master.entity';
export * from './lessor-stakeholder.dto';

export * from './group.dto';
export * from './accountablefunction.dto';
export * from './paymentstatus.dto';
export * from './ownershiptype.dto';
export * from './terrain.dto';
export * from './claimtype.dto';
export * from './subgroup.dto';
export * from './subsubgroup.dto';
export * from './subsubgrouptype.dto';
export * from './subsubgrouptypecategory.dto';
export * from './function.dto';
export * from './divestmentstatus.dto';
export * from './encroachmentstatus.dto';
export * from './encroachmenttype.dto';
export * from './country.dto';

export * from './elp-community.dto';

export * from './title.dto';
export * from './documenttype.dto';
export * from './bank.dto';
export * from './fiscal-file-location.dto';
export * from './division-tbl.dto';
export * from './geodatum.dto';
export * from './continent.dto';
export * from './measure.dto';
export * from './purpose.dto';
export * from './acquisitiontype.dto';

export * from './bankingstatus.dto';
export * from './divestmentstatus.dto';
export * from './landusestatus.dto';
export * from './rightheld.dto';

export * from "./category.dto";
export * from "./measuring_factor.dto";

export * from "./appconfiguration.dto";
export * from "./cabinetshelfref.dto";
export * from "./documenttypecode.dto";
export * from "./rackettrayref.dto";
export * from "./securityclassification.dto";
export * from "./user.dto";
export * from "./pipelinetemplate.dto";
export * from "./pipelinelicensecategory.dto";
export * from "./pipelinelicensestage.dto";
export * from "./pipelinelicensestakeholder.dto";
export * from "./pl_stakeholder_matrix.dto";
export * from "./pl_stage_activity.dto.ts";
export * from "./pl_stakeholder_matrix_raci.dto";
export * from "./hierarchy.dto";

export * from "./securityclassification.dto";
export * from "./itemtype.dto";
export * from "./uom.dto";
export * from "./verificationstatus.dto";
export * from "./yearofsuit.dto";
export * from "./activitystatus.dto";
export * from "./addresstypetbl.dto";
export * from "./batch.dto";
export * from "./category.dto";
export * from "./paymenttype.dto";
export * from "./damagelist.dto";
export * from "./damagestatus.dto";
export * from "./pipelinedetails.dto";
export * from "./licencestatus.dto";
export * from "./pipeline_asset_location.dto";
export * from "./measuring_factor.dto";
export * from "./assetstatus.dto";
export * from "./pipelinesection.dto";
export * from "./pipelineassetlink2.dto";
export * from "./accountablefunctionlink2.dto";
export * from "./pipelinegrade.dto";
export * from "./pigibility.dto";
export * from "./deliverytype.dto";
export * from "./network.dto";
export * from "./ipstatus.dto";
export * from "./stakeholderrep.dto";
export * from "./plactivityactionpersons.dto";
export * from "./pipelinelicencerequest.dto";
export * from "./userstaffdetail.dto";
export * from "./activityactionperson.dto";
export * from "./identityuser.dto";

export * from "./encroachmentasset.dto";
export * from "./encroachmentaction.dto";
export * from "./encroacher.dto";
export * from "./pipelineencroachment.dto";
export * from "./activityactionsperson.dto";
export * from "./plractivityactionhistory.dto";


// eGG DTO
export * from "./yearofsuit.dto";
export * from "./licencestatus.dto";
export * from "./ratestatus.dto";
export * from "./lessorreptype.dto";
export * from "./damagestatus.dto";
export * from "./pole.dto";
export * from "./accessright.dto";
export * from "./cofostatus.dto";
export * from "./counseltype.dto";
export * from "./quantum.dto";
export * from "./subsubgrouptypecategory.dto";
export * from "./incidentquantum.dto";
export * from "./incidentsubcategory.dto";
export * from "./incidentcategory.dto";
export * from "./community.dto";
export * from "./subsubgrouptype.dto";
export * from "./geodatum.dto";
export * from "./document-category.dto";
export * from './areaofspill.dto';

//MFON
export * from "./requestcategory.dto";
export * from "./request_sub_category.dto";
export * from "./obligationperiod.dto";
export * from "./rackettrayref.dto";

//BLESSED
export * from "./activitystatus.dto";
export * from "./addresstypetbl.dto";
export * from "./bankingstatus.dto";
export * from "./batch.dto";
export * from "./cabinetshelfref.dto";
export * from "./category.dto";

export * from "./cleanupstatus.dto";
export * from "./company.dto";
export * from "./continent.dto";
export * from "./currency.dto";
export * from "./damagelist.dto";
export * from "./deliverytype.dto";
export * from "./divestmentstatus.dto";
export * from "./division-tbl.dto";
export * from "./documenttype.dto";
export * from "./itemtype.dto";

export * from "./documenttypecode.dto";
export * from "./expirationstatus.dto";
export * from "./facilityasset.dto";
export * from "./ipstatus.dto";
export * from "./issuedcategory.dto";

export * from "./network.dto";
export * from "./leaseexpiration.dto";


export * from "./community.dto";
export * from "./title.dto";
export * from "./requesttype.dto";
export * from "./company.dto";
export * from "./documenttype.dto";

export * from "./document-sub-category.dto";
export * from "./correspondence-action-party.dto";
export * from "./correspondence-company.dto";
export * from "./correspondence-team.dto";
export * from "./group.dto";
export * from "./accountablefunction.dto";
export * from "./paymentstatus.dto";

export * from "./subgroup.dto";
export * from "./subsubgroup.dto";
export * from "./subsubgrouptype.dto";
export * from "./subsubgrouptypecategory.dto";
// export * from "./function.dto";
export * from "./divestmentstatus.dto";
export * from "./encroachmentstatus.dto";
export * from "./encroachmenttype.dto";
export * from "./country.dto";

export * from "./lga.dto";
export * from "./title.dto";
export * from "./documenttype.dto";
export * from "./bank.dto";
export * from "./fiscal-file-location.dto";
export * from "./division-tbl.dto";
export * from "./geodatum.dto";
export * from "./continent.dto";
export * from "./measure.dto";
export * from "./acquisitiontype.dto";

export * from "./bankingstatus.dto";
export * from "./divestmentstatus.dto";
export * from "./landusestatus.dto";
export * from "./rightheld.dto";
export * from "./category.dto";
export * from "./measuring_factor.dto";
export * from "./documenttypecode.dto";
export * from "./assetstatus.dto";
export * from "./landprefix.dto";
export * from "./lossofuseitems.dto";
export * from "./plrstageactivity.dto";
export * from "./adrassets.dto";
export * from "./adrpersonnel.dto";
export * from "./suitcounsel.dto";
export * from "./suitprogress.dto";
export * from "./counseltype.dto";
export * from "./community.dto";
export * from "./adr.dto";
export * from "./yearofsuit.dto";
export * from "./lorp.dto";
export * from "./stakeholder-response.dto";
export * from "./audittray.dto";
export * from "./damageassessment.dto";
export * from "./damageassessmentbreakdown.dto";
export * from "./damageassessmentdraft.dto";
export * from "./damageassessmentbreakdowndraft.dto";
export * from "./seismicapproval.dto"
export * from './seismicclaimtype.dto';
export * from "./seismiccrew.dto";
export * from './seismiccurrency.dto';
export * from './seismicdivision.dto';
export * from './seismiclinetype.dto';
export * from './seismicoml.dto';
export * from './seismicparty.dto';
export * from './seismicprogram.dto';
export * from './seismicswathno.dto';
export * from './swath.dto';
export * from './program.dto';
export * from './programconfig.dto';
export * from './supervisor.dto';
export * from './vendor.dto';
export * from './oilminerallease.dto';
export * from './numberofapproval.dto';
export * from './approvallevel.dto';
export * from './seismiccontractor.dto';
export * from './seismicclaimantref.dto';
export * from './seismicdamagelist.dto';
export * from './areaofimpact.dto';
export * from './impactedasset.dto';
export * from './impactedcommunity.dto';
export * from './incidentquantumofimpact.dto';
export * from './incidentquantum.dto';
export * from './party.dto';
export * from './application.dto';

export * from "./seismicclaimtype.dto";
export * from "./seismiccommunity.dto";
export * from "./seismiccrew.dto";
export * from "./seismiccurrency.dto";
export * from "./seismicdamagelist.dto";
export * from "./seismicdivision.dto";
export * from "./seismiclinetype.dto";
export * from "./seismicoml.dto";
export * from "./seismicparty.dto";
export * from "./seismicprogram.dto";
export * from "./seismicswathcalc.dto";
export * from "./seismicswathno.dto";
export * from "./damageassessment.dto";
export * from "./damageassessmentdetails.dto";
export * from "./contractor.dto";
export * from "./opllptshistory.dto";
export * from "./seismicmailfrequency.dto"
export * from "./pipelineexpirationnotification.dto"
export * from "./PipelineExpirationNotificationSettings.dto"
export * from "./request-management.dto";
export * from "./request-mgmt-category.dto";
export * from "./request-response.dto";
export * from "./requestcategory.dto";
export * from "./requesttype.dto";
export * from "./request-documents.dto";
export * from "./response-role.dto";
export * from "./incidentregister.dto";
export * from "./incidentaddeddocuments.dto";
export * from "./incidentaddedwitnesses.dto";
export * from "./incidentselectedactivity.dto";
export * from "./incidentselectedconsequence.dto";
export * from "./incidentselectedpartyinvolved.dto";
export * from "./incidentselectedhumanperformance.dto";
export * from "./incidentreassigns.dto";
export * from "./incidenttabsinevent.dto";
export * from "./incidenttabs.dto";
export * from "./incidenteventtype.dto";
export * from "./incidentriskarea.dto";
export * from "./incidentactivity.dto";
export * from "./incidentconsequence.dto";
export * from "./incidenthumanperformance.dto";
export * from "./incidentlocation.dto";
export  * from "./incidentpartyinvolved.dto";
export * from "./incidentabout.dto";
export * from "./incidentownersmapping.dto";
export * from "./incident-response.dto";
export * from './report-reference.dto';
